<template>
  <div class="cmp cmp-evaluate-task-student">
    <cmpCard v-for="(item, index) in taskEvaluates" :key="index" :showFooter="false">
      <div slot="header">
        <el-row type="flex">
          <el-col :span="16" class="left">
            <strong>{{ item.taskName || "任务评价" }}</strong>
          </el-col>
          <el-col :span="4" class="middle text-right">
            <strong style="color: #19A4FF;">总体评价：</strong>
          </el-col>
          <el-col :span="4" class="right">
            <x-star-bar type="warning" :size="24" fill disabled :index="item.starRating"></x-star-bar>
          </el-col>
        </el-row>
      </div>
      <div slot="body">
        <div class="cards-list">
          <template v-for="(v, i) in getCardsList1(item)">
            <div v-if="v.type === 'seat'" class="cards-item cards-item-empty" :key="i"></div>
            <div v-else class="cards-item" :key="i">
              <el-row class="cards-item" type="flex" align="center">
                <div class="left"><i :class="['fa', v.icon]"></i>{{ v.label }}</div>
                <div class="right text-ellipsis">{{ v.value }}</div>
              </el-row>
            </div>
          </template>
        </div>
        <template v-if="item.videoResource.length">
          <h3>视频观看记录</h3>
          <p v-for="(v, i) in item.videoResource" :key="i">
            {{ v.name }}，累计观看时长{{ (v.watchTime / 60).toFixed(2) }}分钟
          </p>
        </template>
        <template v-if="item.workRecords.length">
          <h3>课堂作业</h3>
          <div class="cards-list">
            <template v-for="(v, i) in getCardsList2(item.workRecords)">
              <div v-if="v.type === 'seat'" class="cards-item cards-item-empty" :key="i"></div>
              <div v-else class="cards-item" :key="i">
                <el-row class="top" type="flex" align="center">
                  <div class="left">
                    <i :class="['fa', v.icon]"></i>{{ (workTypeDict[v.worksType] || {}).label1 }}：
                  </div>
                  <div class="right text-ellipsis">{{ v.starRating ? `${v.starRating}星` : "未评价" }}</div>
                </el-row>
                <el-row class="bottom" type="flex" align="center">
                  <x-star-bar type="warning" :size="24" :index="v.starRating || 0" fill disabled></x-star-bar>
                </el-row>
              </div>
            </template>
          </div>
        </template>
      </div>
    </cmpCard>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import cmpCard from "@/components/cmpCard.vue";
import publicUrl from "@/assets/js/interface";
import utils from "@/assets/js/utils.js";

export default {
  name: "cmp-evaluate-task-student",
  components: {
    cmpCard,
  },
  props: {
    data: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      studentProjectEvaluate: {},
      taskEvaluates: [],
      loadingCount: 0,
    };
  },
  computed: {
    ...mapGetters(["workTypeDict"]),
  },
  created() {
    if (this.$route.query.projectId) {
      this.getStudentProjectEvaluate();
    }
  },
  methods: {
    getCardsList1(data) {
      let quizRecords = data.quizRecords || [];
      let arr = [
        // { label: "主题讨论：", value: `参与主题讨论${data.topicNum || 0}次`, icon: "" },
        // {label: '组内聊天：', value: `参与组内聊天${data.groupChatNum || 0}次`, icon: ''},
        { label: "课堂问卷：", value: `提交课堂问卷${data.questionnaireNum || 0}次`, icon: "" },
      ];
      quizRecords.forEach((v) => {
        let value = v.correctNum === -1 ? "未参与" : `答对${v.correctNum || 0}/${v.totalNum || 0}题`;
        arr.unshift({ label: "课堂小测：", value, icon: "" });
      });
      return utils.listWith(arr, 3);
    },
    getCardsList2(data) {
      let arr = [...(data || [])];
      return utils.listWith(arr, 3);
    },
    getStudentProjectEvaluate() {
      this.loadingCount++;
      this.studentProjectEvaluate = {};
      this.$ajax
        .get(publicUrl.studentProjectEvaluate, {
          params: {
            projectId: this.$route.query.projectId,
          },
        })
        .then((res) => {
          if (res.data.code === 0) {
            let _data = (this.studentProjectEvaluate = res.data.data || {});
            this.taskEvaluates = _data.taskEvaluates || [];
          } else {
            this.$message.error(res.data.message);
          }
        })
        .catch((err) => {
          this.$ajaxError(err);
        })
        .finally(() => {
          this.loadingCount--;
        });
    },
  },
};
</script>

<style lang="less" scoped>
.cmp-evaluate-task-student {
  h3 {
    font-size: 20px;
    font-weight: 600;
    color: #464c5b;
    line-height: 2;
  }
  p {
    font-size: 16px;
    color: #464c5b;
    line-height: 2;
  }
  .cards-list {
    display: flex;
    flex-wrap: wrap;
  }
  .cards-item {
    width: 370px;
    margin: 10px auto;
    border-radius: 6px;
    background-color: #fff;
    .el-row {
      padding: 0 30px;
    }
    .left,
    .right,
    .top,
    .bottom {
      height: 60px;
      line-height: 60px;
    }
    .left {
      font-size: 20px;
      font-weight: 500;
      color: #19a4ff;
    }
    .right {
      font-size: 20px;
      color: #464c5b;
    }
    .top {
      border-bottom: 1px solid #dde2e6;
    }
  }
  .cards-item-empty {
    height: 1px;
    visibility: hidden;
    margin-top: 0;
    margin-bottom: 0;
  }
  .x-star-bar {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: space-evenly;
    align-items: center;
  }
}
</style>
